import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { EventAvailable as EventAvailableIcon } from '@mui/icons-material';

/**
 * Shown on a flow that takes real appointments.
 *
 * It outranks the generic "Dynamic" chip on purpose: an owner does not care that this flow
 * exchanges data with an endpoint, they care that tapping it puts someone in their diary.
 */
const LiveBookingChip = ({ size = 'small', sx }) => (
  <Tooltip title="Customers pick a real free slot and the appointment lands in your schedule">
    <Chip
      label="Live booking"
      size={size}
      color="success"
      variant="outlined"
      icon={<EventAvailableIcon />}
      sx={sx}
      data-testid="live-booking-chip"
    />
  </Tooltip>
);

export default LiveBookingChip;
